import { render, staticRenderFns } from "./UserSegmentForm.vue?vue&type=template&id=1441f338&scoped=true"
import script from "./UserSegmentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSegmentForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserSegmentForm.vue?vue&type=style&index=0&id=1441f338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1441f338",
  null
  
)

export default component.exports